import { OrganizationVideo } from 'lib/api/organizationVideo/useOrganizationVideoQuery';
import React from 'react';
import styled from 'styled-components/macro';
import { OrganizationVideosTable } from '../organizationVideosModal/OrganizationVideosTable';
import { VideoSourceType, ISourceType } from './types';

const Content = styled.div`
  padding-top: 32px;
`;

interface Props {
  selectOrganizationVideo?: (url: string, source: ISourceType) => void;
}

export const TabOrganizationVideos = ({ selectOrganizationVideo }: Props) => {
  const handleOnSelectVideo = (video: OrganizationVideo) => {
    const videoUrl = video?.videoUrl;
    if (videoUrl) {
      selectOrganizationVideo?.(videoUrl, {
        sourceType: VideoSourceType.ORGANIZATION_VIDEO,
        sourceId: video.organizationVideoId,
      });
    }
  };
  return (
    <Content>
      <OrganizationVideosTable
        onSelectVideo={handleOnSelectVideo}
        showAddToCovideo={false}
      />
    </Content>
  );
};
